/** @format */

import React from "react";
import Accordion from "react-bootstrap/Accordion";

function AccordionHeader({ data }) {
  return (
    <Accordion.Header>
      <div className="d-flex">
        <div style={{ width: '300px'}}>
          <h4 className="mx-3">{data?.name}</h4>
          <p className="mx-3">{data?.email}</p>
        </div>
        <div>
          <p>(Business Registration Number)</p>
          <h6>{data?.emiratesId ? data?.emiratesId : "-"}</h6>
        </div>
      </div>
    </Accordion.Header>
  );
}

export default AccordionHeader;
